import { setAlert, restart } from "@zf/react-frontend-vite";
import { useEffect } from "react";

const useCustomEvents = (
  storeAction,
  setAttButton,
  setChangeForm,
  setCPlace,
  botStore,
  attButton,
  setUniversalAssetPicker,
  setAssetPickerOptions,
) => {
  useEffect(() => {
    if (storeAction?.type === "DIRECT_LINE/INCOMING_ACTIVITY") {
      if (
        attButton &&
        storeAction?.payload.activity.from.role === "user" &&
        storeAction?.payload.activity.type === "event"
      ) {
        setAttButton(false);
      }
      switch (storeAction?.payload.activity.name) {
        case "ATTACHMENTON":
          setAttButton(true);
          break;

        case "ATTACHMENTOFF":
          setAttButton(false);
          break;

        case "ASSETFORM":
          setChangeForm(true);
          setAssetPickerOptions(storeAction?.payload.activity?.value);
          break;
        case "ASSETFORM_CPLACE":
          setCPlace(true);
          setAssetPickerOptions(storeAction?.payload.activity?.value);
          break;
        case "ASSETPICKER_UNIVERSAL":
          setUniversalAssetPicker(true);
          setAssetPickerOptions(storeAction?.payload.activity?.value);
          break;
        case "TIMEOUT":
          botStore.dispatch(restart());
          botStore.dispatch(
            setAlert({
              alertState: true,
              alertText: "The bot timed out, please try again or restart.",
            }),
          );
          break;
      }
    }
  }, [storeAction]);
};
export default useCustomEvents;
